import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Stars } from './Stars';
import type { Testimonial } from '../types/testimonial';
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <article className="flex h-full flex-col rounded-xl border border-bark/10 bg-cream p-5 shadow-soft sm:p-6" data-id="element-356" data-mp="2p7olvin7jjy7">
      <div className="flex items-center justify-between gap-3" data-id="element-357" data-mp="2u7aybpv7ow5y">
        <Stars data-id="element-358" data-mp="2u8vshedm6d3a" />
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-trust" data-id="element-359" data-mp="2z5vy5o6jxdtv">
          <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-360" data-mp="344fp63005ft3" />
          Verificado
        </span>
      </div>

      <h3 className="mt-4 font-display text-lg leading-snug text-bark" data-id="element-361" data-mp="386u3c9sq7re1">
        {testimonial.headline}
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-ink/80" data-id="element-362" data-mp="19s9agu7wggw1">“{testimonial.quote}”</p>

      <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-363" data-mp="1dtkt2fscw1uq">
        <img src={testimonial.photo} alt={`Foto de ${testimonial.name}`} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-364" data-mp="hsui4it2bxcf" />
        <div className="min-w-0" data-id="element-365" data-mp="d12zqvk28xxd">
          <p className="truncate text-sm font-semibold text-bark" data-id="element-366" data-mp="d01czttommzt">
            {testimonial.name}{' '}
            <span className="font-normal text-ink/60" data-id="element-367" data-mp="80x6xc2215dp">· {testimonial.age}</span>
          </p>
          <p className="truncate text-xs text-ink/60" data-id="element-368" data-mp="31txzgiyef0g">
            {testimonial.city} · {testimonial.date}
          </p>
        </div>
      </div>
    </article>;
}